export default {
  bankConnect: {
    dropSelect: {
      noAccounts: 'bankConnect.dropSelect.noAccounts',
      noBankAccountsFound: 'bankConnect.dropSelect.noBankAccountsFound',
      placeHolder: 'bankConnect.dropSelect.placeHolder',
      selectAllAccounts: {
        name: 'bankConnect.dropSelect.selectAllAccounts.name',
        subtext: 'bankConnect.dropSelect.selectAllAccounts.subtext',
      },
      manageAccounts: 'bankConnect.dropSelect.manageAccounts',
    },
    modal: {
      countryBelgium: 'ConnectBankModal.country.be',
      countryGermany: 'ConnectBankModal.country.de',
      countryBritain: 'ConnectBankModal.country.gb',
      countryFinland: 'ConnectBankModal.country.fi',
      countryFrance: 'ConnectBankModal.country.fr',
      countryNetherlands: 'ConnectBankModal.country.nl',
      countrySweden: 'ConnectBankModal.country.se',
    },
    selectBankAccounts: {
      bankDetails: 'bankConnect.selectBankAccounts.bankDetails', // with variable %BankName%
    },
    bankingInfo: {
      connectAccounts: {
        header: 'bankConnect.bankingInfo.connectAccounts.header',
        details: 'bankConnect.bankingInfo.connectAccounts.details',
        connectButton: 'bankConnect.bankingInfo.connectAccounts.connectButton',
      },
      bankingBalance: {
        accountBalance: 'bankConnect.bankingInfo.bankingBalance.accountBalance',
        unmatchedInvoices: 'bankConnect.bankingInfo.bankingBalance.unmatchedInvoices',
      },
      allAccountsSelected: 'bankConnect.bankingInfo.bankingBalance.allAccountsSelected',
      disconnectBanking: 'bankConnect.bankingInfo.disconnectBanking',
    },
  },
}
